import { render, staticRenderFns } from "./AddItemOtherPlatformComponent.vue?vue&type=template&id=d4479828&scoped=true&"
import script from "./AddItemOtherPlatformComponent.vue?vue&type=script&lang=js&"
export * from "./AddItemOtherPlatformComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddItemOtherPlatformComponent.vue?vue&type=style&index=0&id=d4479828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4479828",
  null
  
)

export default component.exports